import { render, staticRenderFns } from "./PeopleManage.vue?vue&type=template&id=727fa569&scoped=true&"
import script from "./PeopleManage.vue?vue&type=script&lang=js&"
export * from "./PeopleManage.vue?vue&type=script&lang=js&"
import style0 from "./PeopleManage.vue?vue&type=style&index=0&id=727fa569&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727fa569",
  null
  
)

export default component.exports